import * as React from "react";

import { Link } from "react-router-dom";

interface DropdownProps {
    id?: string;
    right?: boolean;
    up?: boolean;
    className?: string;
    onClickHandler?: (event: any) => void;
    children?: JSX.Element | JSX.Element[];
}

export const Dropdown = (props: DropdownProps) => {
    const classes = ["c-dropdown"];
    if (props.right) classes.push("c-dropdown--right");
    if (props.up) classes.push("c-dropdown--up");
    if (props.className) classes.push(props.className);
    return (
        <div
            className={classes.join(" ")}
            onClick={props.onClickHandler}
            id={props.id}
        >
            {props.children}
        </div>
    );
};

interface DropdownMenuProps {
    children?: React.ReactNode;
    dataCy?: string;
}

export const DropdownMenu = (props: DropdownMenuProps) => (
    <div className="c-dropdown__menu" data-cy={props.dataCy}>
        {props.children}
    </div>
);

interface DropdownItemProps {
    id?: string;
    children?: React.ReactNode;
    linkTo?: any;
    onClick?: () => void;
    dataCy?: string;
}

export const DropdownItem = (props: DropdownItemProps) => {
    if (props.linkTo) {
        return (
            <Link
                id={props.id}
                to={props.linkTo}
                className="c-dropdown__item"
                data-cy={props.dataCy}
            >
                {props.children}
            </Link>
        );
    } else {
        return (
            <a
                id={props.id}
                className="c-dropdown__item"
                onClick={props.onClick}
                data-cy={props.dataCy}
            >
                {props.children}
            </a>
        );
    }
};

export default Dropdown;
